<script setup lang="ts">

import Input from "~/components/UI/input.vue";
import {useFormValidation} from "~/composables/validations/useFormValidation";
import {
  useStoreOrderClientForm,
} from "~/composables/store/order/orderForm";

const form = useStoreOrderClientForm()
const {$toast} = useNuxtApp()
const {errors, validatePhone, validateVerifyCode} = useFormValidation();
const error_phone = ref('')
const t = useI18n().t


</script>

<template>
  <div class=" flex flex-row gap-5 ">
    <div class="flex flex-col gap-3  ">
      <div>
        <label for="username"
               class="block text-sm-m font-medium  text-gray-400">{{ $t('input_forms.field.fio') }}</label>
        <div
            class="flex mt-1.5 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-1 focus-within:ring-inset focus-within:ring-primary-green sm:max-w-md">
          <input type="text"
                 required
                 min="2"
                 id="full_name"
                 autocomplete="pila"
                 v-model="form.full_name"
                 class="outline-none block flex-1 border-0 bg-transparent py-3 px-2 text-gray-700 placeholder:text-gray-500 focus:ring-0 sm:text-sm sm:leading-6"
                 :placeholder="$t('input_forms.field.full_name.placeholder')"
          >
        </div>
      </div>
      <div>
        <label for="phone"
               class="block text-sm-m font-medium  text-gray-400">{{ $t('input_forms.field.phone.title') }}</label>
        <div
            class="flex mt-1.5 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-1 focus-within:ring-inset focus-within:ring-primary-green sm:max-w-md">
          <client-only>
            <input type="tel"
                   id="phoneNumber"
                   required
                   v-model="form.phone_number"
                   class="outline-none block flex-1 border-0 bg-transparent py-3 px-2 text-gray-700 placeholder:text-gray-500 focus:ring-0 sm:text-sm sm:leading-6"
                   v-mask="'+7(###) ### ## ##'"
            />
          </client-only>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>